module.exports = __webpack_public_path__ + "img/icon_sec2_08.592bc70e.png";